import { useState } from 'react';
import { DonViCoSo, KhachHang, TaiKhoan } from '@/types/schemas';

/**
 * Hook for managing search field states in the bao-cao-so-du-cong-no feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = () => {
  const [accountDebit, setAccountDebit] = useState<TaiKhoan | null>(null);
  const [accountCredit, setAccountCredit] = useState<TaiKhoan | null>(null);
  const [profession, setProfession] = useState<any>(null);
  const [customer, setCustomer] = useState<KhachHang | null>(null);
  const [unit, setUnit] = useState<DonViCoSo | null>(null);

  return {
    accountDebit,
    setAccountDebit,
    accountCredit,
    setAccountCredit,
    profession,
    setProfession,
    customer,
    setCustomer,
    unit,
    setUnit
  };
};
